import React, { useState, useRef, useEffect, useContext } from "react";
import { UserContext } from "../UserContext";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { sidebarStructure } from "./Structure";
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link } from "react-router-dom";





const Sidemenu = ({ isExpand = true, isExpandOnHover = false }) => {
  const { user, handleLogout } = useContext(UserContext);

  const [openedMenu, setOpenedMenu] = useState({});
  const [activeName, setActiveName] = useState("");
  const activeLink = window.location.pathname;

  const listRef = useRef({});

  const handleNavigate = (path) => {
    setActiveName(path);
  };

  const handleToggle = (name) => {
    const rootEl = name.split(".")[0];

    if (openedMenu[name]?.open === true) {
      setOpenedMenu((prevState) => ({
        ...prevState,
        [name]: {
          open: false,
          height: "0px"
        },
        [rootEl]: {
          open: rootEl === name ? false : true,
          height: `${
            (listRef.current[rootEl]?.scrollHeight || 0) -
            (listRef.current[name]?.scrollHeight || 0)
          }px`
        }
      }));
    } else {
      setOpenedMenu((prevState) => ({
        ...prevState,
        [name]: {
          open: true,
          height: `${listRef.current[name]?.scrollHeight || 0}px`
        },
        [rootEl]: {
          open: true,
          height: `${
            (listRef.current[rootEl]?.scrollHeight || 0) +
            (listRef.current[name]?.scrollHeight || 0)
          }px`
        }
      }));
    }
  };

  const generateIcon = (icon) => {
    var icons_map = {};

    icons_map["airplane"] = (
      <div className="text-pry">
        <Link to="/itinerary">
          <AirplanemodeActiveIcon sx={{color:"#7159EA"}} /> {" "}
          My Trips
        </Link>
      </div>
    );

    icons_map["settings"] = (
        <div className="text-gray-400">
          <Link to="">
            <SettingsIcon className="text-gray-400" /> {" "}
            Setting
          </Link>
        </div>
      );

    icons_map["logout"] = (
    <div className="text-gray-400">
        <LogoutIcon onClick={handleLogout} className="text-gray-400" /> {" "}
        Logout
    </div>
    );

    icons_map["whatsapp"] = (
      <div>
        <WhatsAppIcon sx={{color:"#7159EA"}} />
      </div>
    );

    icons_map["facebook"] = (
      <div>
        <FacebookIcon sx={{color:"#7159EA"}} />
      </div>
    );

    icons_map["email"] = (
      <div>
        <EmailIcon sx={{color:"#7159EA"}} />
      </div>
    );

    icons_map["profiles"] = (
      <div className="text-faded font-light">
        <PeopleAltIcon sx={{color:"#7159EA"}} /> {" "}
        Invite Friends
      </div>
    );

    return icons_map[icon];
  };

  const generateMenu = (item, index, recursive = 0) => {
    if (activeName === "" && activeLink.includes(item.link)) {
      setActiveName(item.name);
    }
    const classesActive = activeName === item.name ? "active" : "";

    return (
      <li key={index}>
        <a
          role="button"
          tabIndex={0}
          id={item.id}
          onClick={() => {
            if ("child" in item) {
              handleToggle(item.name);
            } else if ("link" in item) {
              handleNavigate(item.name);
            }
          }}
          onKeyDown={(event) => {
            const { code } = event;
            if (code === "Space") {
              if ("child" in item) {
                handleToggle(item.name);
              } else if ("link" in item) {
                handleNavigate(item.name);
              }
            }
          }}
          className={[
            "group m-0 flex cursor-pointer rounded-lg items-center justify-between h-12 py-0 pr-3 mb-1 focus:outline-none",
            recursive === 0 ? "pl-4" : recursive === 1 ? "pl-11" : "pl-16",
            activeName === item.name || activeName.split(".")[0] === item.name
              ? `text-blue-600 font-semibold ${
                  item.parent ? "bg-transparent" : "bg-transparent"
                }`
              : `text-gray-500 ${item.parent && ""}`,
            "hover:bg-gray-300/20",
            classesActive
          ].join(" ")}
        >
          <div className="flex items-center gap-3">
            {generateIcon(item.icon)}
            <div
              className={`truncate ${
                isExpand ? "" : isExpandOnHover ? "" : "w-0 h-0 opacity-0"
              }`}
            >
              {item.title}
            </div>
          </div>
          {"child" in item ? (
            <div
              className={`${
                isExpand ? "" : isExpandOnHover ? "" : "w-0 h-0 opacity-0"
              }`}
            >
            </div>
          ) : (
            false
          )}
        </a>
        {"child" in item ? (
          <ul
            ref={(el) => (listRef.current[item.name] = el)}
            className={[
              "transition-max-height overflow-hidden duration-300 ease-in-out",
              isExpand ? "" : isExpandOnHover ? "" : "h-0"
            ].join(" ")}
            style={{ maxHeight: `${openedMenu[item.name]?.height || "0px"}` }}
            key={item.name}
          >
            {item.child.map((value, idx) =>
              generateMenu(value, idx, recursive + 1)
            )}
          </ul>
        ) : (
          false
        )}
      </li>
    );
  };
  

  return (
    <SimpleBar style={{ height: "100%" }} autoHide timeout={100}>
      <div className="mb-0 list-none text-gray-500">
        <div
          className={`my-0 flex flex-col items-center overflow-x-hidden duration-300 ${
            isExpand ? "px-3" : isExpandOnHover ? "px-3" : "px-5"
          }`}
        >
          
        </div>

        <div className="mt-3 mb-10 p-0 leading-10">
          <ul className="list-none text-sm font-normal px-3">
            {sidebarStructure.map((item, index) => generateMenu(item, index))}
          </ul>
        </div>
      </div>
    </SimpleBar>
  );
};

export default Sidemenu;

